module.exports = __webpack_public_path__ + "img/1538478535.84ca2925.jpg";